import { render, staticRenderFns } from "./InsightCard.vue?vue&type=template&id=153a47c9&"
import script from "./InsightCard.vue?vue&type=script&lang=js&"
export * from "./InsightCard.vue?vue&type=script&lang=js&"
import style0 from "./InsightCard.vue?vue&type=style&index=0&id=153a47c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports